// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SobreMim_secao__ld9By {
  padding: 6rem 1.5rem;
  max-width: 900px;
  margin: 0 auto;
}

.SobreMim_etiqueta__gBYbU {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
}

.SobreMim_titulo__tj2hl {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 2rem;
}

.SobreMim_texto__\\+ZfTI {
  color: hsl(215, 20%, 55%);
  font-size: 1.05rem;
  line-height: 1.85;
  margin-bottom: 1.25rem;
}

.SobreMim_destaque__6hvnx {
  color: hsl(217, 91%, 65%);
  font-weight: 600;
}

.SobreMim_infos__8aFKG {
  display: flex;
  gap: 2rem;
  margin-top: 2.5rem;
  flex-wrap: wrap;
}

.SobreMim_infoCard__pzt4f {
  background: hsl(222, 44%, 9%);
  border: 1px solid hsl(222, 30%, 18%);
  border-radius: 0.75rem;
  padding: 1.25rem 1.75rem;
  flex: 1 1;
  min-width: 200px;
}

.SobreMim_infoTitulo__2XCSV {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: hsl(215, 20%, 45%);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 0.5rem;
}

.SobreMim_infoValor__FP83k {
  font-size: 1rem;
  font-weight: 600;
  color: hsl(210, 40%, 92%);
}
`, "",{"version":3,"sources":["webpack://./src/components/SobreMim/SobreMim.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;EACxB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 2rem;\n}\n\n.texto {\n  color: hsl(215, 20%, 55%);\n  font-size: 1.05rem;\n  line-height: 1.85;\n  margin-bottom: 1.25rem;\n}\n\n.destaque {\n  color: hsl(217, 91%, 65%);\n  font-weight: 600;\n}\n\n.infos {\n  display: flex;\n  gap: 2rem;\n  margin-top: 2.5rem;\n  flex-wrap: wrap;\n}\n\n.infoCard {\n  background: hsl(222, 44%, 9%);\n  border: 1px solid hsl(222, 30%, 18%);\n  border-radius: 0.75rem;\n  padding: 1.25rem 1.75rem;\n  flex: 1;\n  min-width: 200px;\n}\n\n.infoTitulo {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.75rem;\n  color: hsl(215, 20%, 45%);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: 0.5rem;\n}\n\n.infoValor {\n  font-size: 1rem;\n  font-weight: 600;\n  color: hsl(210, 40%, 92%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `SobreMim_secao__ld9By`,
	"etiqueta": `SobreMim_etiqueta__gBYbU`,
	"titulo": `SobreMim_titulo__tj2hl`,
	"texto": `SobreMim_texto__+ZfTI`,
	"destaque": `SobreMim_destaque__6hvnx`,
	"infos": `SobreMim_infos__8aFKG`,
	"infoCard": `SobreMim_infoCard__pzt4f`,
	"infoTitulo": `SobreMim_infoTitulo__2XCSV`,
	"infoValor": `SobreMim_infoValor__FP83k`
};
export default ___CSS_LOADER_EXPORT___;
